import { render, staticRenderFns } from "./CoreEPICContact.html?vue&type=template&id=a7bac806&external"
import script from "./CoreEPICContact.vue?vue&type=script&lang=js"
export * from "./CoreEPICContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports